export default "__VITE_ASSET__0bad7103__"